<div id="menu-global">
    <a href="#" data-bs-toggle="collapse" data-bs-target="#menu-open" aria-expanded="false"
        aria-controls="menu-open"><img src="../../../assets/images/icon-menu.svg"> <span class="collapse collapse-horizontal"
            id="menu-open">Menu</span></a>
    <ul class="mt-5">
        <li>
            <a [routerLink]="['/']" [ngClass]="{ 'active': isRouteActive('/'), 'item-menu menu01': true }"  matTooltip="Dashboard">
                <span class="collapse collapse-horizontal" id="menu-open">Dashboard</span></a>
        </li>
        <li>
            <a [routerLink]="['/tickets']"  [ngClass]="{ 'active': isRouteActive('/tickets'), 'item-menu menu02': true }"  matTooltip="Tickets">
                <span class="collapse collapse-horizontal" id="menu-open" >Tickets</span></a>
        </li>
        <li>
            <a [routerLink]="['/tickets', 'chat']"  [ngClass]="{ 'active': isRouteActive('/tickets/chat'), 'item-menu menu-chat': true }"  matTooltip="Chats">
                <span class="collapse collapse-horizontal" id="menu-open"  >Chats</span></a>
        </li>
        <li>
            <a [routerLink]="['/whatsapp']" [ngClass]="{ 'active': isRouteActive('/whatsapp/chat'), 'item-menu menu-whatsapp': true }" matTooltip="Whatsapp">
                <span class="collapse collapse-horizontal" id="menu-open" >Whatsapp</span></a>
        </li>
        <li>
            <a [routerLink]="['/clients']" [ngClass]="{ 'active': isRouteActive('/clients'), 'item-menu menu03': true }" matTooltip="Clientes">
                <span class="collapse collapse-horizontal" id="menu-open"  >Clientes</span></a>
        </li>
        
        <li *ngIf="isAdmin">
            <a [routerLink]="['/settings']" [ngClass]="{ 'active': isRouteActive('/settings'), 'item-menu menu04': true }" matTooltip="Configurações">
                <span class="collapse collapse-horizontal" id="menu-open"  >Configurações</span></a>
        </li>
    </ul>
</div>